// Kept apart from ContentPage: the route's validateSearch needs isContentTab
// eagerly, and importing it from ContentPage would pull the whole page into the
// public entry chunk (scripts/route-code-split-plugin.ts).
export type ContentTab = "pages" | "faq" | "media" | "featured" | "topics" | "testimonials" | "footer";

export const CONTENT_TABS: Array<{ value: ContentTab; label: string }> = [
  { value: "pages", label: "Pages" },
  { value: "faq", label: "FAQ" },
  { value: "media", label: "Media" },
  { value: "featured", label: "Featured" },
  { value: "topics", label: "Teme" },
  { value: "testimonials", label: "Testimoniali" },
  { value: "footer", label: "Footer" },
];

export function isContentTab(value: unknown): value is ContentTab {
  return typeof value === "string" && CONTENT_TABS.some((t) => t.value === value);
}
